import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import EntryPage from "../src/viewChanger";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
class EntryPoint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
  }

  componentDidMount() {
    const allowed = localStorage.getItem("allowed");
    if (allowed === "true") {
      this.setState({ open: false });
    }
    document.title = "CanaWho";
  }

  callbackFunction = (childData) => {
    if (!childData) {
      localStorage.setItem("allowed", "true");
      this.setState({ open: childData });
    }
  };

  render() {
    return (
      <BrowserRouter>
        {this.state.open ? (
          <EntryPage parentCallback={this.callbackFunction} />
        ) : (
          <App />
        )}
      </BrowserRouter>
    );
  }
}

ReactDOM.render(<EntryPoint />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
